
import { computed, defineComponent, onMounted, ref, getCurrentInstance, watch } from "vue-demi";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";
import {
  API_TRoleTemplate,
  TRoleTemplate_Dropdown_CaseCreation,
  convertJobTemplatesToSelectCaseCreation,
} from "@/models/role_templates";
import { SMCases, SMQuestionnaire, SMRoles } from "@/store";

export default defineComponent({
  name: "VEmployerServicesExtensionTemplate",

  components: {
    Banner: () => import("@/components/V2/Banner/Banner.vue"),
  },

  setup() {
    const instance = getCurrentInstance()?.proxy;
    const route = instance?.$route;
    const router = instance?.$router;

    const jobTemplateId = ref(0);

    const jobTemplates = ref<TRoleTemplate_Dropdown_CaseCreation[]>([]);

    const dropdownKey = ref(0);

    function selectJobTemplate() {
      if (jobTemplates.value.length === 1) {
        jobTemplateId.value = jobTemplates.value[0].value;

        dropdownKey.value += 1;
      }
    }

    async function fetchJobTemplates() {
      const params = {
        archive: false,
      };

      const { data } = await axios.get<API_TRoleTemplate[]>(API_ROUTES.ROLE_TEMPLATES(), {
        params,
      });

      if (!data) return;

      const completed = data.filter((item) => item.completed === true);

      jobTemplates.value = completed.map((item: API_TRoleTemplate) =>
        convertJobTemplatesToSelectCaseCreation(item)
      );

      selectJobTemplate();
    }

    onMounted(() => fetchJobTemplates());

    async function createJobTemplate() {
      await SMRoles.createRoleTemplate();
    }

    const employeeId = computed(() => Number(route.params.employeeId ?? 0));

    const loading = ref(false);

    async function onStart() {
      try {
        loading.value = true;

        const params = {
          alias: "candidate_assessment",
          role_template_id: jobTemplateId.value,
          target_user: employeeId.value,
        };

        const { data } = await axios.get(API_ROUTES.CREATE_EXTENSION_CASE(params));

        if (!data) return;

        let caseId = 0;

        if (typeof data === "number") caseId = data;

        if (typeof data === "object") caseId = data?.case_id ?? 0;

        if (!caseId) return;

        await router.push(`/cases/${caseId}/dashboard/${SMCases.tabId}`);
      } finally {
        loading.value = false;
      }
    }

    const needsUpdate = computed(() => SMQuestionnaire.isOpen);

    watch(
      needsUpdate,
      (value) => {
        if (!value) {
          fetchJobTemplates();

          selectJobTemplate();
        }
      },
      { immediate: true }
    );

    return {
      jobTemplateId,
      jobTemplates,
      dropdownKey,
      employeeId,
      loading,
      createJobTemplate,
      onStart,
    };
  },
});
